import {ADD_CUSTOMER_REQUEST, CUSTOMER_REQUEST_CLEAR, DELETE_CUSTOMER_REQUEST, GET_CUSTOMER_REQUEST, GET_SURVEY_STATS_CLEAR, GET_SURVEY_STATS_REQUEST} from '../constants/reducer.const';

export const addCustomer = (payload)=>({type: ADD_CUSTOMER_REQUEST, payload});
export const getCustomerList = (payload)=>({type: GET_CUSTOMER_REQUEST, payload});
export const clearCutsomerData = ()=>({type: CUSTOMER_REQUEST_CLEAR, payload: {}});
export const deleteCutsomerData = (payload)=>({type: DELETE_CUSTOMER_REQUEST, payload});
export const getSurveyStatsAction = (payload)=>({type: GET_SURVEY_STATS_REQUEST, payload});
export const getSurveyStatsClear= ()=>({type: GET_SURVEY_STATS_CLEAR, payload: {}});
